<template>
    <div>
        <div class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-hdr d-block pt-4 p-3">
                    <div class="ml-auto mb-3 text-right">
                        <exportCSV class="link btn buttons-csv buttons-html5 btn-primary mr-2"
                            :data="exportData"
                            :fields="exportFields"
                            :header="exportHeaders"
                            type="csv"
                            :escapeCsv="false"
                            :name="exportFileName">
                            <span>CSV</span>
                        </exportCSV>
                        <!-- <button class="btn buttons-csv buttons-html5 btn-secondary ml-2" type="button" title="Generate PDF">
                            <span class="mr-3">PDF</span>
                            <i class="arrow-down fas fa-angle-down"></i> 
                        </button> -->
                    </div>
                    <div class="row">
                        <div class="col-sm-12 col-md-6 align-items-center justify-content-start">
                            <div class="dataTables_filter mb-2">
                                <label class="d-flex mb-0">
                                    <input type="search" class="form-control border-top-right-radius-0 border-bottom-right-radius-0 ml-0 shadow-inset-1" :placeholder="$t('label.search')" v-model="searchReward" @keypress.enter="filterSearchReward">
                                    <button class="input-group-text d-inline-flex width-3 align-items-center justify-content-center border-bottom-left-radius-0 border-top-left-radius-0 border-left-0 search" @click="filterSearchReward()">
                                        <i class="fas fa-search"></i>
                                    </button>
                                </label>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-6 mb-2"> 
                            <div class="form-group">
                                <div class="input-group">
                                    <div class="input-group-prepend w-100">
                                        <label class="input-group-text border-right-0">
                                            <i class="fas fa-store"></i>
                                        </label>
                                        <multiselect :value="selectedOutlet" label="text" track-by="id" :options="outlet" :searchable="false" :show-labels="false" openDirection="below" @select="filterByOutlet">
                                            <template slot="option" slot-scope="{ option }">{{option.text}}</template>
                                        </multiselect>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="custom-control custom-checkbox mb-2">
                        <input type="checkbox" class="custom-control-input" id="showEnabled" @change="filterEnable($event)" v-model="isEnable">
                        <label class="custom-control-label" for="showEnabled">{{$t('label.show_enable')}}</label>
                    </div>
                    <a class="link text-primary" @click="clearFilter()">{{$t('button_link.clear_filter')}}</a>
                </div>
                <div class="panel-container">
                    <div class="panel-content">
                        <ul class="nav nav-tabs" role="tablist">
                            <li class="nav-item" v-for="c in $i18n.messages[$i18n.locale].tab.rewardStatusTabs" :key="c.id">
                                <a :class="{'active': selectedTab == c.id}" class="nav-link" role="tab" @click="filterStatus(c.id)">{{c.text}}</a>
                            </li>
                        </ul>
                        <div v-if="isSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
                            <b-spinner label="Loading..."></b-spinner>
                        </div>
                        <div class="panel-tag mt-3" v-if="!isSpinnerShow && totalEntries == 0">
                            {{$t('table.no_records')}}
                        </div>
                        <div v-if="!isSpinnerShow && totalEntries != 0" class="dataTables_wrapper dt-bootstrap4">
                            <div class="row justify-content-end mt-2">
                                <div class="col-auto pt-2">
                                    <span>{{$t('table.pagination', {'startPage': startPage, 'endPage': endPage, 'totalEntries': totalEntries,})}}</span>
                                </div>
                                <div class="col-auto">
                                    <b-pagination class="ml-3" v-model="currentPage" :per-page="perPage" :total-rows="totalEntries" @input="handlePagination" aria-controls="tblProductItems"></b-pagination>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 overflow-auto">
                                    <b-table striped hover bordered :fields="fields" :items="rewardItems" responsive="sm">
                                        <template #cell(index)="data">
                                            {{ data.index + startPage }}
                                        </template>
                                        <template #cell(qrcode)="data">
                                            <div class="position-relative">
                                                <a class="link qrDetails" @click="copyQRCode($event)">
                                                    <span class="qr-link badge border border-primary text-primary fw-400">{{data.item.qrcode}}</span>
                                                    <input type="hidden" :value="data.item.qrcode"/>
                                                </a>
                                                <span style="display: none" class="copy-success badge badge-success"><i class="fas fa-check mr-1"></i>{{$t('label.qr_code_copied')}}</span>
                                            </div>
                                        </template>
                                        <template #cell(reward)="data">
                                            {{data.item.title == "" ? '-' : data.item.title}}
                                        </template>
                                        <template #cell(duration)="data">
                                            <span class="d-block">{{rearrangeDate(data.item.startDate)}} -</span>
                                            <span >{{rearrangeDate(data.item.endDate)}}</span>
                                        </template>
                                        <template #cell(progress)="data">
                                            <p class="mb-0">{{$t('table.value.redeem')}} {{data.item.sold}}/{{data.item.total}}</p>
                                            <b-progress :value="data.item.sold" :max="data.item.total"></b-progress>
                                        </template>
                                        <template #cell(isEnable)="data">
                                            <span class="badge" :class="data.item.isEnable == 1 ? 'badge-primary' : 'badge-secondary'">{{data.item.isEnable == 1 ? $t('table.value.enable') : $t('table.value.disable')}}</span>
                                        </template>
                                        <template #cell(action)="data">
                                            <div v-if="selectedTab != 'inactive'" class="row">
                                                <div class="col text-center">
                                                    <a class="text-primary link d-block" title="Edit Reward" @click="showEditReward(data.item.rewardID)">
                                                        <i class="fal fa-pen"></i>
                                                    </a>
                                                </div>
                                                <div class="col text-center">
                                                    <a class="text-primary link" title="Delete Reward" @click="showDeleteReward(data.item.rewardID, data.item.title)">
                                                        <i class="fal fa-trash"></i>
                                                    </a>
                                                </div>
                                            </div>
                                            <div v-else>
                                                <span class="badge badge-warning">{{$t('table.value.deleted')}}</span>
                                            </div>
                                        </template>
                                    </b-table>
                                 </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div :class="{'show': editToggleModal }" class="modal fade">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header border-bottom">
                        <h5 class="modal-title h4">{{$t('header.edit') + $t(`subMenu.salon_menu_reward`)}}
                            <small class="m-0 text-muted">{{$t(`subMenu.salon_menu_reward`)}} '{{editRewardTitle}}'</small>
                        </h5>
                        <button type="button" class="close" @click="editToggleModal = false">
                            <span aria-hidden="true"><i class="fal fa-times"></i></span>
                        </button>
                    </div>
                    <div class="modal-body edit-modal-body">
                        <rewardForm ref="rewardForm" :isEdit="true" @returnRewardList="returnRewardList"></rewardForm> 
                    </div>
                </div>
            </div>
        </div>
        <deleteModal ref="deleteModal" @performConfirmAction="deleteReward"></deleteModal>
    </div>
</template>
<script>
import DeleteModal from './../../Delete_Modal'
import moment from 'moment'
import tab from '@/assets/js/dashboard/tab.js'
import tbl from '@/assets/js/dashboard/table-header.js'
import exportTbl from '@/assets/js/dashboard/export-table-header.js'
import {handleSessionExpired, getOutletName, setReturnData} from '@/assets/js/dashboard/dashboard.js'
import {convertTimestampToDateTime, convertDateToTimestamp} from '@/assets/js/dashboard/utilities.js'
import RewardForm from './Reward_Form'
export default {
    name: "rewardList",
    components:{
        RewardForm, DeleteModal
    },
    data(){
        return{
            searchReward: "",
            outlet: [], selectedOutlet: {},
            isSpinnerShow: false, editToggleModal: false,
            editRewardTitle: "",
            isEnable: false, isExpand: "Show",
            isEnableFilter: "", statusFilter: "",
            rewardStatus: tab.rewardStatusTabs, selectedTab: "active",
            rewardItems: [],rewardID: 0,
            exportHeaders: [], exportData: [], exportFileName: "",
            page: 0, totalEntries: 0, totalPage: 0, startPage: 1, endPage: 0, perPage: 100, currentPage: 1,
            rewardExportData: []
        }
    },
    computed:{
        fields(){
            return [
                {key: "index", label: "#", thClass: 'thead-themed align-middle', tdClass: 'align-middle'},
                {key: "qrcode", label: this.$i18n.t('table.header.qr_code'), thClass: 'thead-themed align-middle', tdClass: 'align-middle'},
                {key: "reward", label: this.$i18n.t('table.header.title'), thClass: 'thead-themed align-middle', tdClass: 'align-middle'},
                {key: "duration", label: this.$i18n.t('table.header.duration'), thClass: 'thead-themed align-middle', tdClass: 'align-middle'},
                {key: "progress", label: this.$i18n.t('table.header.progress'), thClass: 'thead-themed align-middle', tdClass: 'align-middle'},
                {key: "isEnable", label: this.$i18n.t('table.header.enable'), thClass: 'thead-themed align-middle', tdClass: 'align-middle text-center'},
                {key: "action", label: "", thClass: 'thead-themed align-middle', tdClass: 'align-middle text-center'},
            ]
        },
        exportFields(){
            var ret = {}
            ret["#"] = "index"
            ret[(this.$i18n.t('table.header.qr_code')).toUpperCase()] = "qrCode"
            ret[(this.$i18n.t('table.header.title')).toUpperCase()] = "reward"
            ret[(this.$i18n.t('table.header.duration')).toUpperCase()] = "duration"
            ret[(this.$i18n.t('table.header.progress')).toUpperCase()] = "progress"
            ret[(this.$i18n.t('table.header.enable')).toUpperCase()] = "isEnable"
            return ret
        }
    },
    watch:{
        "$i18n.locale"(val){
            this.setExportData(this.rewardExportData)
        }
    },
    methods:{
        closeModal(isError){
            if(!isError){
                this.$refs.deleteModal.toggleModal = false
                this.filterRewardQR("", "")
            }
            this.$parent.$parent.isModalShow = false;
        },
        returnRewardList(selectedOutlet){
            this.selectedOutlet = selectedOutlet;
            this.editToggleModal = false
            this.filterRewardQR("", "")
        },
        clearFilter(){
            this.selectedOutlet = this.outlet[0];
            this.isEnable = false;
            this.selectedTab = "active";
            this.isEnableFilter = this.statusFilter = this.searchReward = "";
            this.filterRewardQR(this.isEnableFilter, this.statusFilter)
        },
        filterSearchReward(){
            var strFilter = this.searchReward == "" ? "" : "&search=" + this.searchReward;
            this.getRewardQR(strFilter)
        },
        filterByOutlet(item){
            this.selectedOutlet = item;
            this.filterRewardQR(this.isEnableFilter, this.statusFilter)
        },
        filterEnable(e){
            this.isEnable = e.target.checked ? true : false;
            this.isEnableFilter = "&isEnable=" + (this.isEnable ? "1" : "0");
            this.filterRewardQR(this.isEnableFilter, this.statusFilter)
        },
        filterStatus(id){
            this.selectedTab = id;
            this.statusFilter = "&active="
            if(id == "all"){
                this.statusFilter = ""
            }else{
                this.statusFilter = "&active=" + (id == "active" ? "1" : "0");
            }
            this.filterRewardQR(this.isEnableFilter, this.statusFilter)
        },
        filterRewardQR(isEnable, status){   
            var strFilter = isEnable + status;
            this.getRewardQR(strFilter)
        },
        handlePagination(pg){
            if(pg != null){
                this.page = pg - 1
                this.filterRewardQR(this.isEnableFilter, this.statusFilter)
            }
        },
        showEditReward(rewardID){
            this.editToggleModal = true;
            var data = {}
            for(var i=0; i<this.rewardItems.length; i++){
                if(this.rewardItems[i].rewardID == rewardID){
                    this.editRewardTitle = this.rewardItems[i].title
                    data = this.rewardItems[i];
                    break
                }
            }
            this.$refs.rewardForm.editReward(data);
        },
        showDeleteReward(id, title){
            this.rewardID = id
            var modalTitle = this.$i18n.t('header.delete') + this.$i18n.t('subMenu.salon_menu_reward')
            var message = this.$i18n.t('message.confirmation.question', {'action': this.$i18n.t('message.confirmation.action.delete'), 'item': title})
            this.$refs.deleteModal.showModal(modalTitle, message)
        },
        deleteReward(){
            let $vm = this;
            const url = $vm.$api.OUTLET + "/" + this.selectedOutlet.id + this.$api.MENU_REWARD_QR + "/" + this.rewardID + $vm.$api.DELETE
            $vm.$axios({
                method: 'post', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')},
            })
            .then((response) => {
                if(response.status == 200){
                    $vm.$refs.deleteModal.toggleModal = false
                    var message = $vm.$i18n.t('subMenu.salon_menu_reward') + $vm.$i18n.t('message.success.success', {'action':  $vm.$i18n.t('message.success.action.delete')})
                    $vm.$parent.$parent.setModal($vm, false, true, message)
                }
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
        },
        copyQRCode(e){
            var input = e.target.nextSibling
            input.select();
            document.execCommand("copy");

            var isQRCopy = e.target.parentElement.nextSibling
            isQRCopy.style.display = isQRCopy.style.display == 'none' ? 'block' : 'none';

            setTimeout(() => { isQRCopy.style.display = 'none'; }, 2000); 
        },
        rearrangeDate(date){
            return moment(date, 'YYYY/MM/DD').format('DD/MM/YYYY')
        },
        async getRewardQR(strFilter){
            const url = this.$api.OUTLET +"/" + this.selectedOutlet.id + this.$api.MENU_REWARD_QR + "?page=" + this.page + strFilter;
            let $vm = this;
            $vm.totalEntries = 0;
            $vm.isSpinnerShow = true;

            $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                var result = $vm.rearrangeData(response.data.result)
                var retData = setReturnData(result, response.data.count, $vm.page)
                $vm.rewardItems = retData.result
                $vm.totalEntries = $vm.selectedTab == 'active' ? $vm.rewardItems.length : response.data.count;
                $vm.totalPage = retData.totalPage;

                $vm.startPage = retData.startPage;
                $vm.endPage = retData.endPage;
                $vm.isSpinnerShow = false;
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            await this.getExportData(strFilter)
        },
        rearrangeData(result){
            var data = []
            if(this.selectedTab == 'active'){
                for(var i=0; i<result.length; i++){
                    var endDate = moment(result[i].endDate, 'YYYY/MM/DD').toDate()
                    if(endDate > new Date()){
                        if(result[i].isEnable == 1){
                            data.push(result[i])
                        }
                    }
                }
                return data
            }else{
                return result
            } 
        },
        async getExportData(strFilter){
            let $vm = this;
            const url = this.$api.OUTLET +"/" + this.selectedOutlet.id + this.$api.MENU_REWARD_QR + "?" + strFilter;
            var result = []
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result = $vm.rearrangeData(response.data.result)
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            this.rewardExportData = result
            this.setExportData(result)
        },
        setExportData(data){
            this.exportData = []
            let header = this.$msg.REPORT.HEADER + this.$i18n.t('sideNav.navSalonMenu') + " - " + this.$i18n.t('subMenu.salon_menu_reward')
            this.exportHeaders = [header, this.$i18n.t('table.report_generate') + moment().format(this.$msg.CST.DATE_TIME_24)," "];

            this.exportFileName = header.split(" ").join("_") +  this.$msg.REPORT.CSV

            for(var i=0; i<data.length; i++){
                this.exportData.push({
                    index: i+1,
                    qrCode: data[i].qrcode,
                    reward: data[i].title == "" ? '-' : data[i].title,
                    duration: this.rearrangeDate(data[i].startDate) + " - " + this.rearrangeDate(data[i].endDate),
                    progress: this.$i18n.t('table.value.redeem') + " " + data[i].sold + "/" +  data[i].total,
                    isEnable: data[i].isEnable == 1 ? this.$i18n.t('table.value.enable') : this.$i18n.t('table.value.disable')
                })
            }
        },
    },
    async mounted(){
        let $vm = this;
        $vm.outlet = JSON.parse($vm.$store.state.outlets);
        $vm.selectedOutlet = $vm.outlet[0];
        $vm.statusFilter = "&active=1";
        $vm.filterRewardQR("", $vm.statusFilter)
    }
}
</script>
<style scoped>
.export-button{
    margin-top: -4.65em;
    margin-left: 1em;
}
.search:hover{
    background: #d6d6d6;
    border: 1px solid #d6d6d6;
}
.nav-link, .link{
    cursor: pointer;
}
.mt-negative-2{
    margin-top: -2em;
}

.mt-negative-2>i:hover, .mt-negative-2>i:active{
    color: #ffffff !important;
}
.qr-link:hover{
    color: #ffffff !important;
    background: #b19dce;
}

.copy-success{
    position: absolute;
    top: 2em;
    right: 7.5em;
    opacity: 0.7;
}
.text-underline{
    text-decoration: underline !important;
}
.show{
    display: block;
}
.edit-modal-body{
    height: 80vh;
    overflow-y: auto;
}
</style>